export class UpdateSourceAccountRequest {
    'name';
    'sourceAccountAttributes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountAttributes",
            "baseName": "sourceAccountAttributes",
            "type": "UpdateSourceAccountAttributesInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSourceAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
